(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  // 目录：从正文 h2 生成锚点；不足 2 个标题就不显示。滚动时高亮当前段。
  document.querySelectorAll('.jn-article').forEach(function (root) {
    var body = root.querySelector('[data-article-body]');
    var toc = root.querySelector('[data-article-toc]');
    var list = root.querySelector('[data-article-toc-list]');
    var layout = root.querySelector('.jn-article__layout');
    if (!body || !toc || !list) return;
    var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (heads.length < 2) { if (layout) layout.classList.add('jn-article__layout--no-toc'); return; }
    var used = {};
    heads.forEach(function (h, i) {
      var slug = (h.textContent || '').trim().toLowerCase().replace(/[^\w一-龥]+/g, '-').replace(/^-+|-+$/g, '') || 'section-' + (i + 1);
      if (used[slug]) slug += '-' + (i + 1);
      used[slug] = true;
      if (!h.id) h.id = slug;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
    if ('IntersectionObserver' in window) {
      var links = list.querySelectorAll('a');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          var a = list.querySelector('a[href="#' + e.target.id + '"]');
          if (a) a.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jn-customers-redirect"]) return;
  try {
    
  document.querySelectorAll('.jn-customers[data-redirect]').forEach(function (el) {
    var url = el.dataset.redirect;
    if (url && url !== location.pathname) setTimeout(function () { location.replace(url); }, 1500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jn-lights-toggle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLights(root) {
      if (root.dataset.jnLightsReady) return;
      root.dataset.jnLightsReady = '1';

      var sw = root.querySelector('.jn-lights__switch');
      var art = root.querySelector('.jn-lights__art');
      var label = root.querySelector('.jn-lights__label');
      if (!sw || !art || sw.disabled) return;

      function sync() {
        var on = sw.checked;
        art.classList.toggle('is-on', on);
        if (label) label.textContent = on ? label.dataset.on : label.dataset.off;
      }

      sw.addEventListener('change', sync);
      // 点图片也能切换：走原生 click 让 change 事件照常触发
      art.addEventListener('click', function () {
        sw.click();
      });
      sync();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.jn-lights').forEach(initLights);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    // 主题编辑器改设置后 section 会重渲染，重新绑定
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jn-product-dimensions"] && !Shopify.designMode) return;
  try {
    
  /* 产品页尺寸段（审计 #13 / #44）。两件事：
     1) 尺寸表跟着变体走：把当前选中尺寸那一组留下、其余折叠，并给出「Show all sizes」；
        变体级 dim_* 存在时顺带换掉上面的数字。
     2) 层高定制：把输入框的值同步成购买盒表单里的隐藏 properties[…] 字段
        （买盒的 <form> 在 sections/product.liquid，不归本段，所以只能从外面塞）。
     变体切换事件全站没有派发，这里靠观察选项按钮的 aria-pressed 属性变化来感知。
     没有这段 JS 时页面完全可读：尺寸表全展开、层高框只是不生效。 */
  if (!customElements.get('jn-dims')) {
    customElements.define(
      'jn-dims',
      class JnDims extends HTMLElement {
        connectedCallback() {
          this.data = null;
          var tag = this.querySelector('[data-jn-dimdata]');
          if (tag) {
            try {
              this.data = JSON.parse(tag.textContent);
            } catch (e) {
              this.data = null;
            }
          }

          this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-jn-chartgroup]'));
          this.toggle = this.querySelector('[data-jn-charttoggle]');
          this.list = this.querySelector('[data-jn-dimlist]');
          this.fit = this.querySelector('[data-jn-fit]');
          this.fitInput = this.querySelector('[data-jn-fit-input]');
          this.fitOk = this.querySelector('[data-jn-fit-ok]');
          this.expanded = false;

          if (this.fitInput) {
            this._onFit = this.syncFit.bind(this);
            this.fitInput.addEventListener('input', this._onFit);
            this.fitInput.addEventListener('change', this._onFit);
            /* bfcache / 自动填充回来时表单里的隐藏字段已经没了，补一次 */
            this.syncFit();
          }

          if (this.toggle) {
            this._onToggle = this.showAll.bind(this);
            this.toggle.addEventListener('click', this._onToggle);
          }

          if (this.data && this.data.variants && this.data.variants.length) {
            this.idInput =
              document.querySelector('[data-variant-id]') ||
              document.querySelector('form[action*="/cart/add"] [name="id"]');
            this.sync();
            /* 选项按钮的 aria-pressed 是变体切换唯一可观察的 DOM 信号 */
            var self = this;
            this.mo = new MutationObserver(function () {
              if (self.raf) return;
              self.raf = window.requestAnimationFrame(function () {
                self.raf = 0;
                self.sync();
              });
            });
            this.mo.observe(document.body, {
              subtree: true,
              attributes: true,
              attributeFilter: ['aria-pressed']
            });
          }
        }

        disconnectedCallback() {
          if (this.mo) this.mo.disconnect();
          if (this.raf) window.cancelAnimationFrame(this.raf);
        }

        /* 比对用的规范化：去引号 / 空格 / 破折号统一，"17\"" 和 "17 in" 都落到 "17" 开头 */
        static norm(v) {
          return String(v == null ? '' : v)
            .toLowerCase()
            .replace(/[‘’“”′″"']/g, '')
            .replace(/[–—]/g, '-')
            .replace(/\s+/g, '');
        }

        currentVariant() {
          if (!this.idInput || !this.data) return null;
          var id = parseInt(this.idInput.value, 10);
          if (!id) return null;
          var list = this.data.variants || [];
          for (var i = 0; i < list.length; i++) {
            if (list[i].id === id) return list[i];
          }
          return null;
        }

        sync() {
          var v = this.currentVariant();
          this.applyNumbers(v);
          this.applyChart(v);
        }

        /* 变体级 dim_* 存在时换数字；缺项整条隐藏，不留上一个变体的残值 */
        applyNumbers(v) {
          if (!this.list || !v) return;
          var unit = (this.data && this.data.unitLb) || 'lb';
          var self = this;
          ['w', 'h', 'd', 'c', 'wt'].forEach(function (k) {
            var row = self.list.querySelector('[data-jn-dim="' + k + '"]');
            if (!row) return;
            var raw = v[k];
            if (raw === undefined || raw === null || raw === '') {
              row.hidden = true;
              return;
            }
            var num = Math.round(parseFloat(raw) * 100) / 100;
            if (!isFinite(num) || num <= 0) {
              row.hidden = true;
              return;
            }
            var cell = row.querySelector('[data-jn-dimval]');
            if (cell) cell.textContent = k === 'wt' ? num + ' ' + unit : num + '"';
            row.hidden = false;
          });
        }

        /* 尺寸表：当且仅当有且只有一组能对上当前变体时才折叠，对不上就全展开 */
        applyChart(v) {
          if (!this.groups.length || this.expanded) return;
          var match = null;
          if (v && v.o && v.o.length) {
            var opts = v.o.map(JnDims.norm).filter(function (x) {
              return x.length > 1;
            });
            var hits = this.groups.filter(function (g) {
              var head = JnDims.norm(g.getAttribute('data-jn-size'));
              if (head.length < 2) return false;
              return opts.some(function (o) {
                return o === head || o.indexOf(head) === 0 || head.indexOf(o) === 0;
              });
            });
            if (hits.length === 1) match = hits[0];
          }
          this.groups.forEach(function (g) {
            g.hidden = !!match && g !== match;
          });
          if (this.toggle) this.toggle.hidden = !match;
        }

        showAll() {
          this.expanded = true;
          this.groups.forEach(function (g) {
            g.hidden = false;
          });
          if (this.toggle) this.toggle.hidden = true;
        }

        /* 层高：写进主购买表单的隐藏 properties[…]；清空就把字段删掉，别留空属性。
           只认 [data-product-form]（sections/product.liquid 的那一个）——页面上还有
           「Pairs well with」和推荐位的加购表单，层高绝不能跟着别的商品走。 */
        productForm() {
          var form = document.querySelector('form[data-product-form]');
          if (form) return form;
          var idInput = document.querySelector('[data-variant-id]');
          return idInput ? idInput.closest('form[action*="/cart/add"]') : null;
        }

        syncFit() {
          if (!this.fitInput || !this.fit) return;
          var form = this.productForm();
          if (!form) return;
          var name = (this.fit.getAttribute('data-jn-fit-name') || 'Ceiling height').replace(/[[\]]/g, '');
          var val = this.fitInput.value.trim().slice(0, 40);
          var el = form.querySelector('input[data-jn-fit-hidden]');
          if (!val) {
            if (el) el.parentNode.removeChild(el);
          } else {
            if (!el) {
              el = document.createElement('input');
              el.type = 'hidden';
              el.setAttribute('data-jn-fit-hidden', '');
              form.appendChild(el);
            }
            el.name = 'properties[' + name + ']';
            el.value = val;
          }
          if (this.fitOk) this.fitOk.hidden = !val;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jn-rooms-rail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // 左右按钮：滚一张卡的宽度（卡宽 + gap）。通过 aria-controls 定位本实例的 rail，多实例互不影响。
    document.addEventListener('click', function (event) {
      var button = event.target.closest('.jn-rooms__btn');
      if (!button) return;
      var track = document.getElementById(button.getAttribute('aria-controls'));
      if (!track) return;
      var item = track.querySelector('.jn-rooms__item');
      if (!item) return;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      var step = item.getBoundingClientRect().width + gap;
      track.scrollBy({
        left: step * Number(button.dataset.dir || 1),
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    });

    // 主题编辑器里点选某个 block 时，把它滚到可视区
    document.addEventListener('shopify:block:select', function (event) {
      var item = event.target && event.target.closest ? event.target.closest('.jn-rooms__item') : null;
      if (!item) return;
      item.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'auto' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '.jn-recs[data-url]';
    var hasIO = 'IntersectionObserver' in window;

    // 注入后的 .jn-reveal 不在 base.js 的观察名单里，这里用同一套 is-pending / is-in 类补上（样式在 critical.css）
    var revealIO = hasIO
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.remove('is-pending');
            entry.target.classList.add('is-in');
            revealIO.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px' })
      : null;

    function reveal(box) {
      if (!revealIO) return;
      box.querySelectorAll('.jn-reveal').forEach(function (el) {
        if (el.getBoundingClientRect().top > window.innerHeight) {
          el.classList.add('is-pending');
          revealIO.observe(el);
        }
      });
    }

    function load(box) {
      if (box.dataset.state) return;
      box.dataset.state = 'loading';
      fetch(box.dataset.url)
        .then(function (response) {
          return response.ok ? response.text() : Promise.reject(new Error(String(response.status)));
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.getElementById(box.id);
          if (!fresh || !fresh.innerHTML.trim()) {
            box.dataset.state = 'empty';
            return;
          }
          box.innerHTML = fresh.innerHTML;
          // 标题以整页渲染时算好的 data-heading 为准；没有标题就把 h2 和 aria-labelledby 一起拿掉，不留空 h2
          var heading = box.querySelector('[data-recs-heading]');
          if (heading) {
            if (box.dataset.heading) {
              heading.textContent = box.dataset.heading;
            } else {
              var labelled = box.querySelector('[aria-labelledby="' + heading.id + '"]');
              if (labelled) labelled.removeAttribute('aria-labelledby');
              heading.remove();
            }
          }
          box.dataset.state = 'loaded';
          reveal(box);
        })
        .catch(function () {
          box.dataset.state = 'error';
        });
    }

    function init(root) {
      (root || document).querySelectorAll(SELECTOR).forEach(function (box) {
        if (box.dataset.state) return;
        if (!hasIO) {
          load(box);
          return;
        }
        // 容器进到视口下方 400px 内才请求，避免和首屏抢带宽
        var io = new IntersectionObserver(function (entries) {
          var near = entries.some(function (entry) { return entry.isIntersecting; });
          if (!near) return;
          io.disconnect();
          load(box);
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(box);
      });
    }

    init();
    // 主题编辑器里重渲染本段后重新拉一次
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* 产品页：变体切换 / 图库 / sticky 加购条 / 加购事件。无 Liquid，文案从 data-t-* 读。 */
  if (!customElements.get('jn-product')) {
    customElements.define(
      'jn-product',
      class JnProduct extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-product-form]');
          this.idInput = this.querySelector('[data-variant-id]');
          this.qtyInput = this.querySelector('[data-quantity]');
          this.atc = this.querySelector('[data-atc]');
          this.atcLabel = this.querySelector('[data-atc-label]');
          this.priceEl = this.querySelector('[data-price]');
          this.msg = this.querySelector('[data-msg]');
          /* 0908 修复(R12)：加速结账按钮块 + 售罄说明行，随变体可售状态一起切 */
          this.dynamic = this.querySelector('[data-dynamic]');
          this.oos = this.querySelector('[data-oos]');
          this.main = this.querySelector('[data-main]');
          this.imgs = this.main ? Array.prototype.slice.call(this.main.querySelectorAll('img')) : [];
          /* 初始大图不一定是第 0 张（变体带图时是那张），从 .is-current 反推，别写死 0 */
          this.currentIndex = 0;
          for (var ci = 0; ci < this.imgs.length; ci++) {
            if (this.imgs[ci].classList.contains('is-current')) {
              this.currentIndex = ci;
              break;
            }
          }
          this.imgCounter = this.querySelector('[data-img-i]');
          this.comboBox = this.querySelector('[data-combo]');
          this.comboText = this.querySelector('[data-combo-text]');
          this.comboFix = this.querySelector('[data-combo-fix]');
          this.lastPick = -1;
          this.suggestion = null;
          this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
          this.thumbStrip = this.querySelector('[data-thumbstrip]');
          this.thumbWrap = this.querySelector('[data-thumbwrap]');
          this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-option]'));
          this.buy = this.querySelector('[data-buy]');
          this.bar = this.querySelector('[data-bar]');
          this.barImg = this.querySelector('[data-bar-img]');
          this.barVariant = this.querySelector('[data-bar-variant]');
          this.barPrice = this.querySelector('[data-bar-price]');
          this.barBtn = this.querySelector('[data-bar-atc]');

          var json = this.querySelector('[data-variants]');
          try {
            this.variants = json ? JSON.parse(json.textContent) : [];
          } catch (e) {
            this.variants = [];
          }

          this.pending = false;
          this.timer = null;
          if (this.thumbStrip) {
            this._onThumbSync = this.syncThumbNav.bind(this);
            this.thumbStrip.addEventListener('scroll', this._onThumbSync, { passive: true });
            window.addEventListener('resize', this._onThumbSync);
            if (window.ResizeObserver) {
              this.thumbRO = new ResizeObserver(this._onThumbSync);
              this.thumbRO.observe(this.thumbStrip);
            }
            /* 缩略图是 lazy 的，字体/图片到位前宽度算不准，落定后再补一次 */
            this.syncThumbNav();
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._onThumbSync);
            window.addEventListener('load', this._onThumbSync, { once: true });
          }
          this.current = this.find(this.selected());
          this.markAvailability(this.selected());
          this.syncQty();
          if (this.qtyInput) {
            this._onQtyInput = this.syncQty.bind(this);
            this.qtyInput.addEventListener('change', this._onQtyInput);
            this.qtyInput.addEventListener('blur', this._onQtyInput);
          }

          this._onClick = this._onClick.bind(this);
          this._onPrefetch = this._onPrefetch.bind(this);
          this._onSubmit = this._onSubmit.bind(this);
          this._onCartUpdated = this._onCartUpdated.bind(this);
          this._onCartError = this._onCartError.bind(this);
          this._onFormAdding = this._onFormAdding.bind(this);
          this.addEventListener('click', this._onClick);
          /* 缩略图 hover / 聚焦时先把那张大图取回来，点下去就不会闪一下 */
          this.addEventListener('mouseover', this._onPrefetch);
          this.addEventListener('focusin', this._onPrefetch);
          /* 审计 #11：触屏上 mouseover 只比 click 早 2ms，等于没有预取（实测 430–500ms 纯灰块）。
             pointerdown / touchstart 在手指按下去那一刻就开始取图，能抢出几十到几百毫秒。 */
          this.addEventListener('pointerdown', this._onPrefetch);
          this.addEventListener('touchstart', this._onPrefetch, { passive: true });
          /* 相邻两张的预取等页面 load 完再做，别跟 LCP 主图抢带宽 */
          if (document.readyState === 'complete') {
            this._idlePrefetch();
          } else {
            this._onLoadPrefetch = this._idlePrefetch.bind(this);
            window.addEventListener('load', this._onLoadPrefetch, { once: true });
          }
          if (this.form) {
            this.form.addEventListener('submit', this._onSubmit);
            /* cart.js 自动拦截表单提交时在表单上派发这三个事件（detail.form / detail.message） */
            this.form.addEventListener('cart:adding', this._onFormAdding);
            this.form.addEventListener('cart:added', this._onCartUpdated);
            this.form.addEventListener('cart:error', this._onCartError);
          }

          /* sticky 条：观察对象是加购按钮本身，不是购买盒 —— 购买盒现在装着描述 / Product Size /
             规格，桌面端有 4000px 高，盯着它的话要滚到快见底才亮，等于这条 bar 不存在。
             审计 #9：判定也从"滚过表单"换成"真按钮不在视口里"。
             原来只有 boundingClientRect.top < 0（已经滚过按钮）才亮，实测手机上翻转点在
             scrollY=2100、而真按钮底边在 1931 —— 这条 bar 只在客户已经走过按钮之后才出现，
             对最需要它的前 2.7 屏完全无效。
             手机上再加一条：还没滚到按钮、但已经滚过 200px 就先给入口（真按钮一进视口自动收起，
             不会同屏出现两颗加购按钮）。桌面端 mobile=false，行为跟原来一致。 */
          this.stickyRef = this.atc || this.form || this.buy;
          if (this.bar && this.stickyRef) {
            this._onBarSync = this.queueBarSync.bind(this);
            window.addEventListener('scroll', this._onBarSync, { passive: true });
            window.addEventListener('resize', this._onBarSync);
            if ('IntersectionObserver' in window) {
              this.io = new IntersectionObserver(this._onBarSync, { threshold: 0 });
              this.io.observe(this.stickyRef);
            }
            this.syncBar();
          }
        }

        /* 滚动里每帧最多算一次，避免 scroll 上直接读 rect 抖动 */
        queueBarSync() {
          if (this._barRaf) return;
          var self = this;
          var tick = function () {
            self._barRaf = 0;
            self.syncBar();
          };
          if (window.requestAnimationFrame) this._barRaf = window.requestAnimationFrame(tick);
          else this._barRaf = setTimeout(tick, 16);
        }

        syncBar() {
          var bar = this.bar;
          var ref = this.stickyRef;
          if (!bar || !ref) return;
          var r = ref.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight || 0;
          var mobile = window.matchMedia ? window.matchMedia('(max-width: 959px)').matches : false;
          var y = window.pageYOffset || document.documentElement.scrollTop || 0;
          var on;
          if (r.bottom > 0 && r.top < vh) {
            on = false; /* 真按钮就在屏幕上：不跟它抢 */
          } else if (r.top < 0) {
            on = true; /* 已经滚过按钮 */
          } else {
            on = mobile && y > 200; /* 还没滚到按钮：手机上滚一屏内就给入口 */
          }
          if (on === this._barOn) return;
          this._barOn = on;
          bar.classList.toggle('is-show', on);
          bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) bar.removeAttribute('inert');
          else bar.setAttribute('inert', '');
        }

        disconnectedCallback() {
          this.removeEventListener('click', this._onClick);
          this.removeEventListener('mouseover', this._onPrefetch);
          this.removeEventListener('focusin', this._onPrefetch);
          this.removeEventListener('pointerdown', this._onPrefetch);
          this.removeEventListener('touchstart', this._onPrefetch);
          if (this._onBarSync) {
            window.removeEventListener('scroll', this._onBarSync);
            window.removeEventListener('resize', this._onBarSync);
          }
          if (this._onLoadPrefetch) window.removeEventListener('load', this._onLoadPrefetch);
          clearTimeout(this._imgTimer);
          if (this.form) {
            this.form.removeEventListener('submit', this._onSubmit);
            this.form.removeEventListener('cart:adding', this._onFormAdding);
            this.form.removeEventListener('cart:added', this._onCartUpdated);
            this.form.removeEventListener('cart:error', this._onCartError);
          }
          if (this._onThumbSync) {
            window.removeEventListener('resize', this._onThumbSync);
            if (this.thumbStrip) this.thumbStrip.removeEventListener('scroll', this._onThumbSync);
          }
          if (this.thumbRO) this.thumbRO.disconnect();
          if (this.io) this.io.disconnect();
          clearTimeout(this.timer);
        }

        /* ---------- 事件 ---------- */
        _onClick(e) {
          var navBtn = e.target.closest('[data-thumb-scroll]');
          if (navBtn) { this._onThumbScroll(parseInt(navBtn.dataset.thumbScroll, 10) || 1); return; }
          var thumb = e.target.closest('[data-thumb]');
          if (thumb && this.contains(thumb)) {
            this.show(parseInt(thumb.dataset.index, 10));
            return;
          }
          var fixBtn = e.target.closest('[data-combo-fix]');
          if (fixBtn && this.contains(fixBtn)) {
            this.selectVariant(this.suggestion);
            return;
          }
          var opt = e.target.closest('[data-option] button[data-value]');
          if (opt && this.contains(opt)) {
            this.pick(opt);
            return;
          }
          var qtyBtn = e.target.closest('[data-qty-step]');
          if (qtyBtn && this.contains(qtyBtn)) {
            this.stepQty(parseInt(qtyBtn.dataset.qtyStep, 10) || 1);
            return;
          }
          var codeBtn = e.target.closest('[data-copy-code]');
          if (codeBtn && this.contains(codeBtn)) {
            this.copyCode(codeBtn);
            return;
          }
          if (e.target.closest('[data-bar-atc]') && this.atc && !this.atc.disabled) {
            this.atc.click();
          }
        }

        /* 数量步进器：只改表单里那个 quantity input 的值，下限 1，减到 1 时把减号置灰。
           0908 修复(R28)：加上限（data-qty-max，默认 10）。原来无上限，直接键入 999
           能成功进车（实测 item_count 1000 / total $3,792,000）。 */
        qtyMax() {
          var m = parseInt(this.dataset.qtyMax, 10);
          return isNaN(m) || m < 1 ? 10 : m;
        }

        stepQty(delta) {
          if (!this.qtyInput) return;
          var n = parseInt(this.qtyInput.value, 10);
          if (isNaN(n) || n < 1) n = 1;
          n = n + delta;
          if (n < 1) n = 1;
          this.qtyInput.value = n;
          this.syncQty();
        }

        syncQty() {
          if (!this.qtyInput) return;
          var max = this.qtyMax();
          var n = parseInt(this.qtyInput.value, 10);
          if (isNaN(n) || n < 1) {
            n = 1;
            this.qtyInput.value = n;
          }
          /* 0908 修复(R28)：超上限就钳回上限并说明为什么，别默默改数字。 */
          if (n > max) {
            n = max;
            this.qtyInput.value = n;
            var note = this.dataset.tQtyMax;
            if (note) this.showMsg(note);
          }
          var minus = this.querySelector('[data-qty-step="-1"]');
          if (minus) minus.disabled = n <= 1;
          var plus = this.querySelector('[data-qty-step="1"]');
          if (plus) plus.disabled = n >= max;
        }

        /* 优惠码：点一下复制到剪贴板，1.6s 后恢复。文案在 Liquid 里，这里只切 class。 */
        copyCode(btn) {
          var code = btn.getAttribute('data-copy-code') || '';
          if (!code) return;
          var flash = function () {
            btn.classList.add('is-copied');
            clearTimeout(btn.jnCopyTimer);
            btn.jnCopyTimer = setTimeout(function () {
              btn.classList.remove('is-copied');
            }, 1600);
          };
          /* 剪贴板 API 在无 user activation / 无权限时会 reject，回退到 execCommand；
             两条路都失败就不给假反馈，码本身在页面上是可读文本，可以手抄。 */
          var legacy = function () {
            var ta = document.createElement('textarea');
            ta.value = code;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.top = '0';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            var ok = false;
            try {
              ok = document.execCommand('copy');
            } catch (err) {
              ok = false;
            }
            document.body.removeChild(ta);
            if (ok) flash();
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(flash, legacy);
          } else {
            legacy();
          }
        }

        _onSubmit(e) {
          /* 加速结账按钮（Shop Pay / PayPal / Google Pay，以及钱包不可用时 Shopify 退回的
             "Buy it now"）就在同一个 product 表单里，按下去也算这个表单的 submit。
             这条 submit 必须走 Shopify 自己的结账流程，不能被 cart.js 的 document 级拦截
             改写成 AJAX 加购——所以只 stopPropagation，不 preventDefault。 */
          var submitter = e.submitter || document.activeElement;
          if (submitter && submitter.closest && submitter.closest('.shopify-payment-button')) {
            e.stopPropagation();
            return;
          }
          if (!(window.JN && window.JN.cartReady)) return; /* cartReady 未设：不拦截，交给 cart.js 的 document 级拦截或原生提交 /cart/add */
          e.preventDefault();
          e.stopPropagation(); /* 别让 cart.js 的 document 级 submit 拦截再加一次 */
          if (this.pending || !this.current || !this.current.available) return;
          /* 0908 修复(R28)：提交前再钳一次 —— 直接键入数字后不 blur 就点加购时，change 事件
             不一定已经跑过，syncQty 的钳位就赶不上这一单。
             提示本身由 startPending 负责留住（cart.js 还会再派发一次 cart:adding）。 */
          this.syncQty();
          this.startPending();
          window.JN.emit('cart:add', {
            id: this.current.id,
            quantity: this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1,
            sectionId: this.dataset.sectionId,
            form: this.form,
            /* 0908 修复(R02)：层高等定制项是 jn-product-dimensions 写进本表单的
               hidden properties[…]，原来这个 detail 不带它们，cart.js 只读 d.properties，
               结果页面写着"Saved. we cut the chain to fit."、订单里却是 properties:{}。 */
            properties: this.formProperties()
          });
        }

        /* 0908 修复(R02)：从表单里收 properties[...] 键，空对象时返回 null（别给购物车塞空属性）。 */
        formProperties() {
          if (!this.form || typeof FormData === 'undefined') return null;
          var props = null;
          var data = new FormData(this.form);
          data.forEach(function (value, name) {
            var m = /^properties\[(.+)\]$/.exec(name);
            if (!m) return;
            var v = String(value == null ? '' : value).trim();
            if (!v) return;
            if (!props) props = {};
            props[m[1]] = v;
          });
          return props;
        }

        /* cart.js 拦截表单提交后派发（表单级）：进入 adding 态 */
        _onFormAdding() {
          this.startPending();
        }

        startPending() {
          this.pending = true;
          /* 0908 修复(R28)：数量钳位提示要活过这次清屏 —— 加购路上 startPending 会被调用两次
             （_onSubmit 一次、cart.js 派发的 cart:adding 再一次），原样 hideMsg 的话客户
             只看到数量自己从 999 变成 10、没有任何解释。别的提示（错误/组合）照旧清掉。 */
          var qtyNote = this.dataset.tQtyMax;
          var keepQtyNote = !!(qtyNote && this.msg && !this.msg.hidden && this.msg.textContent === qtyNote);
          this.hideMsg();
          if (keepQtyNote) this.showMsg(qtyNote);
          this.setAtc('adding');
          var self = this;
          clearTimeout(this.timer);
          this.timer = setTimeout(function () {
            if (self.pending) {
              self.showMsg('Still adding your item. Please wait — you only need to click once.');
            }
          }, 8000);
        }

        _onCartUpdated() {
          if (!this.pending) return;
          this.pending = false;
          clearTimeout(this.timer);
          if (this.msg && this.msg.textContent.indexOf('Still adding your item.') === 0) this.hideMsg();
          this.setAtc('added');
          var self = this;
          this.timer = setTimeout(function () {
            self.setAtc(self.stateFor(self.current));
          }, 1500);
        }

        _onCartError(e) {
          if (!this.pending) return;
          this.pending = false;
          clearTimeout(this.timer);
          this.setAtc(this.stateFor(this.current));
          var m = e && e.detail && e.detail.message;
          if (m) this.showMsg(m);
        }

        /* ---------- 变体 ---------- */
        selected() {
          return this.groups.map(function (g) {
            var b = g.querySelector('button[aria-pressed="true"]');
            return b ? b.dataset.value : null;
          });
        }

        find(sel) {
          if (!this.variants.length) return null;
          if (!sel.length) return this.variants[0];
          for (var i = 0; i < this.variants.length; i++) {
            var v = this.variants[i];
            var ok = v.options.length === sel.length;
            for (var j = 0; ok && j < sel.length; j++) ok = v.options[j] === sel[j];
            if (ok) return v;
          }
          return null;
        }

        pick(btn) {
          var group = btn.closest('[data-option]');
          if (!group) return;
          Array.prototype.forEach.call(group.querySelectorAll('button[data-value]'), function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var lab = group.querySelector('[data-option-value]');
          if (lab) lab.textContent = btn.dataset.value;
          /* 记住客户刚动的是哪一组：组合配不出货时以"他刚选的那个值"为锚点给建议，
             绝不建议他改回刚点的那个（审计 #1）。 */
          var gi = parseInt(group.dataset.optionIndex, 10);
          this.lastPick = isNaN(gi) ? -1 : gi;
          var sel = this.selected();
          this.apply(this.find(sel), sel);
          this.markAvailability(sel);
        }

        /* 0908 修复(R12)：可售状态一变，加速结账块和售罄说明行跟着走。
           v 为 null（组合配不出变体）时同样收起 —— 那时表单里的 id 还停在上一个变体，
           让 PayPal 可点等于让客户结走一个他没选的变体。 */
        syncBuyState(v) {
          var ok = !!(v && v.available);
          if (this.dynamic) this.dynamic.hidden = !ok;
          if (this.oos) this.oos.hidden = !(v && !v.available);
        }

        apply(v, sel) {
          this.current = v;
          this.syncBuyState(v);
          /* 0908 修复(R01)：变体切换全站没有事件可听，「Pairs well with」原来只能读页面初始值。
             这里广播一次，assets/bundle.js 据此重算 This item 行和 Total。 */
          try {
            document.dispatchEvent(new CustomEvent('jn:variant', { detail: { variant: v || null, sectionId: this.dataset.sectionId } }));
          } catch (err) {
            /* CustomEvent 构造在极老浏览器里会抛：不影响主流程 */
          }
          if (!v) {
            this.setAtc('unavailable');
            this.showCombo(sel || this.selected());
            return;
          }
          this.hideCombo();
          if (this.idInput) this.idInput.value = v.id;
          this.renderPrice(v);
          this.setAtc(this.pending ? 'adding' : this.stateFor(v));
          if (this.barVariant) this.barVariant.textContent = v.label ? '· ' + v.options.join(' · ') : '';
          if (typeof v.media === 'number') this.show(v.media);
          if (this.variants.length > 1 && window.history && window.history.replaceState) {
            try {
              var u = new URL(window.location.href);
              u.searchParams.set('variant', v.id);
              window.history.replaceState(window.history.state, '', u.toString());
            } catch (err) {
              /* 老浏览器没有 URL：不更新地址栏 */
            }
          }
        }

        stateFor(v) {
          if (!v) return 'unavailable';
          return v.available ? 'add' : 'sold_out';
        }

        renderPrice(v) {
          var span = document.createElement('span');
          span.className = 'jn-price';
          span.textContent = v.price_html;
          if (v.compare_html) {
            var s = document.createElement('s');
            s.className = 'jn-price__compare';
            s.textContent = v.compare_html;
            span.appendChild(document.createTextNode(' '));
            span.appendChild(s);
          }
          if (this.priceEl) {
            this.priceEl.textContent = '';
            this.priceEl.appendChild(span);
          }
          if (this.barPrice) this.barPrice.textContent = v.price_html;
        }

        /* 选项三态（审计 #1 BLOCKER）：
             is-unavailable = 这个值在任何组合下都买不到（划掉）
             is-conflict    = 值本身有货，只是跟当前另一个选项配不出变体（虚线，照样能点）
             当前选中的那颗两个都不打 —— 原来客户刚点 Matte Black，自己刚选的 18" 反而被划掉，
             加上价格还停在上一个变体，最合理的解读就是"这款没货了"，直接走人。 */
        markAvailability(sel) {
          var variants = this.variants;
          var tConflict = this.dataset.tConflict || '';
          var tSold = this.dataset.tSoldOut || '';
          this.groups.forEach(function (group, gi) {
            Array.prototype.forEach.call(group.querySelectorAll('button[data-value]'), function (b) {
              var val = b.dataset.value;
              var pressed = b.getAttribute('aria-pressed') === 'true';
              var sellable = variants.some(function (v) {
                return v.available && v.options[gi] === val;
              });
              var fits = variants.some(function (v) {
                if (!v.available || v.options[gi] !== val) return false;
                for (var gj = 0; gj < sel.length; gj++) {
                  if (gj !== gi && sel[gj] !== null && v.options[gj] !== sel[gj]) return false;
                }
                return true;
              });
              var dead = !sellable;
              var clash = sellable && !fits && !pressed;
              b.classList.toggle('is-unavailable', dead);
              b.classList.toggle('is-conflict', clash);

              /* 划线 / 虚线读屏看不见，状态要进可访问名。
                 色板是空按钮、名字全靠 aria-label，改 aria-label；
                 尺寸 / 胶囊按钮有可见文字，补一个 visually-hidden 尾巴，
                 别用 aria-label 盖掉按钮上那行尺寸。 */
              var note = dead ? tSold : clash ? tConflict : '';
              if (b.classList.contains('jn-swatch')) {
                b.setAttribute('aria-label', note ? val + ' — ' + note : val);
              } else {
                var tail = b.querySelector('[data-state-note]');
                if (note) {
                  if (!tail) {
                    tail = document.createElement('span');
                    tail.className = 'visually-hidden';
                    tail.setAttribute('data-state-note', '');
                    b.appendChild(tail);
                  }
                  tail.textContent = ' — ' + note;
                } else if (tail) {
                  tail.parentNode.removeChild(tail);
                }
              }
            });
          });
        }

        /* 组合配不出变体时说人话 + 给一条出路（审计 #1）：
           以客户刚点的那个值为锚点，挑一个"改动最少、同分最便宜"的可售组合；
           价格换成该锚点的最低可售价，绝不停在上一个变体的价上。 */
        showCombo(sel) {
          var box = this.comboBox;
          if (!box) return;
          var gi = typeof this.lastPick === 'number' && this.lastPick >= 0 ? this.lastPick : -1;
          var anchor = gi >= 0 ? sel[gi] : null;
          var pool = [];
          var i, j, v;
          for (i = 0; i < this.variants.length; i++) {
            v = this.variants[i];
            if (!v.available) continue;
            if (anchor !== null && v.options[gi] !== anchor) continue;
            pool.push(v);
          }
          /* 锚点值本身全店都没货：退回"全店可售"找建议，文案也退回通用版 */
          if (!pool.length && anchor !== null) {
            for (i = 0; i < this.variants.length; i++) {
              if (this.variants[i].available) pool.push(this.variants[i]);
            }
            anchor = null;
            gi = -1;
          }
          var best = null;
          var bestScore = -1;
          var minV = null;
          for (i = 0; i < pool.length; i++) {
            v = pool[i];
            var diff = 0;
            for (j = 0; j < sel.length; j++) {
              if (sel[j] !== null && v.options[j] !== sel[j]) diff++;
            }
            var score = diff * 100000000 + v.price;
            if (bestScore < 0 || score < bestScore) {
              bestScore = score;
              best = v;
            }
            if (!minV || v.price < minV.price) minV = v;
          }
          if (minV) {
            var from = (this.dataset.tFrom || '~PRICE~').replace('~PRICE~', function () {
              return minV.price_html;
            });
            if (this.priceEl) {
              /* 跟 renderPrice 保持同一个结构：外面那层 <p class="jn-pdp__price">，
                 里面永远是一个 span.jn-price，别把价格样式给弄没了 */
              var pspan = document.createElement('span');
              pspan.className = 'jn-price';
              pspan.textContent = from;
              this.priceEl.textContent = '';
              this.priceEl.appendChild(pspan);
            }
            if (this.barPrice) this.barPrice.textContent = from;
          }
          var text;
          if (anchor !== null) {
            var others = [];
            for (j = 0; j < sel.length; j++) {
              if (j !== gi && sel[j]) others.push(sel[j]);
            }
            text = (this.dataset.tCombo || '{value} is not available in {options}.')
              .replace('{value}', function () {
                return anchor;
              })
              .replace('{options}', function () {
                return others.join(' · ');
              });
          } else {
            text = this.dataset.tComboAny || 'That combination is not available.';
          }
          if (this.comboText) this.comboText.textContent = text;
          this.suggestion = best;
          if (this.comboFix) {
            if (best) {
              var changed = [];
              for (j = 0; j < sel.length; j++) {
                if (j !== gi && sel[j] !== null && best.options[j] !== sel[j]) changed.push(best.options[j]);
              }
              if (!changed.length) changed = best.options.slice();
              var label = (this.dataset.tSwitch || 'Switch to {options}').replace('{options}', function () {
                return changed.join(' · ');
              });
              this.comboFix.textContent = label + ' — ' + best.price_html;
              this.comboFix.hidden = false;
            } else {
              this.comboFix.hidden = true;
            }
          }
          box.hidden = false;
        }

        hideCombo() {
          this.suggestion = null;
          if (this.comboBox) this.comboBox.hidden = true;
          if (this.comboFix) this.comboFix.hidden = true;
        }

        /* 一键切到建议的可售组合（审计 #1 里那颗 "Switch to 36" – 13 Lights" 按钮） */
        selectVariant(v) {
          if (!v) return;
          this.groups.forEach(function (g, gi) {
            var val = v.options[gi];
            Array.prototype.forEach.call(g.querySelectorAll('button[data-value]'), function (b) {
              b.setAttribute('aria-pressed', b.dataset.value === val ? 'true' : 'false');
            });
            var lab = g.querySelector('[data-option-value]');
            if (lab) lab.textContent = val;
          });
          this.lastPick = -1;
          var sel = this.selected();
          this.apply(v, sel);
          this.markAvailability(sel);
          /* 按钮自己会被隐藏，焦点不能掉到 body 上；preventScroll 避免手机上跳一下 */
          if (this.atc && this.atc.focus) {
            try {
              this.atc.focus({ preventScroll: true });
            } catch (err) {
              this.atc.focus();
            }
          }
        }

        /* ---------- 加购按钮状态 ---------- */
        setAtc(state) {
          var t = this.dataset;
          var label = t.tAdd;
          var disabled = false;
          if (state === 'adding') {
            label = t.tAdding;
            disabled = true;
          } else if (state === 'added') {
            label = t.tAdded;
            disabled = true;
          } else if (state === 'sold_out') {
            label = t.tSoldOut;
            disabled = true;
          } else if (state === 'unavailable') {
            label = t.tUnavailable;
            disabled = true;
          }
          if (this.atcLabel) this.atcLabel.textContent = label;
          if (this.atc) this.atc.disabled = disabled;
          if (this.barBtn) {
            this.barBtn.textContent = label;
            this.barBtn.disabled = disabled;
          }
        }

        showMsg(text) {
          if (!this.msg) return;
          this.msg.textContent = text;
          this.msg.hidden = false;
        }

        hideMsg() {
          if (!this.msg) return;
          this.msg.textContent = '';
          this.msg.hidden = true;
        }

        /* ---------- 图库 ---------- */
        _onThumbScroll(dir) {
          var strip = this.thumbStrip;
          if (!strip) return;
          var one = strip.querySelector('[data-thumb]');
          var step = one ? one.getBoundingClientRect().width + 10 : 90;
          // 尊重 prefers-reduced-motion：平滑滚动是动效，关了动效就直接跳过去
          var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          strip.scrollBy({ left: step * 3 * dir, behavior: reduced ? 'auto' : 'smooth' });
        }

        /* 左右按钮只在缩略图条真的滚得动时出现，并在滚到头时禁用那一侧。
           原来按"图片数 > 4"出按钮，实测 5/6/7 张图在 1440 宽下一排就放得下，
           按钮点了纹丝不动（Jack：多图片的左右选择不了）。 */
        syncThumbNav() {
          var strip = this.thumbStrip;
          var wrap = this.thumbWrap;
          if (!strip || !wrap) return;
          var overflow = strip.scrollWidth > strip.clientWidth + 2;
          wrap.classList.toggle('has-overflow', overflow);
          var max = strip.scrollWidth - strip.clientWidth;
          var x = strip.scrollLeft;
          var prev = wrap.querySelector('[data-thumb-scroll="-1"]');
          var next = wrap.querySelector('[data-thumb-scroll="1"]');
          var atStart = !overflow || x <= 1;
          var atEnd = !overflow || x >= max - 1;
          if (prev) prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
          if (next) next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
          /* 两侧渐隐跟着走（审计 #33）：滚到头那一侧的渐隐收掉，不然像还有内容 */
          wrap.classList.toggle('at-start', atStart);
          wrap.classList.toggle('at-end', atEnd);
        }

        /* 审计 #48：换 Finish 后主图对了，但选中的缩略图还在视口外（实测在 x=428–500，
           375 屏根本看不到），看上去像缩略图跟颜色没关系。
           用 strip.scrollTo 而不是 thumb.scrollIntoView —— 后者会把整个页面也纵向滚一下。 */
        scrollThumbIntoView(i) {
          var strip = this.thumbStrip;
          var t = this.thumbs[i];
          if (!strip || !t) return;
          if (strip.scrollWidth <= strip.clientWidth + 2) return;
          var sr = strip.getBoundingClientRect();
          var tr = t.getBoundingClientRect();
          if (tr.left >= sr.left - 1 && tr.right <= sr.right + 1) return; /* 已经在视野里，别乱动 */
          var delta = tr.left - sr.left - (sr.width - tr.width) / 2;
          var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (strip.scrollTo) {
            strip.scrollTo({ left: strip.scrollLeft + delta, behavior: reduced ? 'auto' : 'smooth' });
          } else {
            strip.scrollLeft = strip.scrollLeft + delta;
          }
        }

        /* 空闲时把当前图前后各一张先取回来（审计 #11）：滑到相邻那张时已经有像素了 */
        _idlePrefetch() {
          var self = this;
          var run = function () {
            var i = self.currentIndex || 0;
            self.hydrate(i + 1);
            self.hydrate(i - 1);
          };
          if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 2000 });
          else setTimeout(run, 1200);
        }

        _onPrefetch(e) {
          var t = e.target.closest && e.target.closest('[data-thumb]');
          if (t) this.hydrate(parseInt(t.dataset.index, 10));
        }

        hydrate(i) {
          var im = this.imgs[i];
          if (!im || !im.dataset.src) return;
          im.srcset = im.dataset.srcset || '';
          im.src = im.dataset.src;
          delete im.dataset.src;
          delete im.dataset.srcset;
        }

        show(i) {
          if (!this.imgs.length || i < 0 || i >= this.imgs.length) return;
          var self = this;
          var im = this.imgs[i];
          this.hydrate(i);
          this.currentIndex = i;
          this.thumbs.forEach(function (t, k) {
            t.setAttribute('aria-current', k === i ? 'true' : 'false');
          });
          this.scrollThumbIntoView(i);
          if (this.imgCounter) this.imgCounter.textContent = i + 1;
          if (this.barImg && this.thumbs[i]) {
            var t = this.thumbs[i].querySelector('img');
            if (t) {
              this.barImg.removeAttribute('srcset');
              this.barImg.removeAttribute('sizes');
              this.barImg.src = t.currentSrc || t.src;
            }
          }
          /* 审计 #11：原来点下去立刻把旧图淡出、新图那会儿一个像素都没有，
             430–500ms 之间屏幕上是纯灰块（本机直连 LAX 的成绩，4G 只会更长）。
             改成"新图 load 完才切 is-current"，没到位就一直留着旧图 —— 宁可晚半秒也不给空白。 */
          var swap = function () {
            if (self.currentIndex !== i) return; /* 期间又点了别的，这次作废 */
            self.imgs.forEach(function (m, k) {
              m.classList.toggle('is-current', k === i);
            });
            self._idlePrefetch();
          };
          if (im.complete && im.naturalWidth > 0) {
            swap();
          } else {
            im.addEventListener('load', swap, { once: true });
            im.addEventListener('error', swap, { once: true });
            /* 兜底：3s 还没 load（图挂了 / 网络卡死）也切过去，别永远停在旧图 */
            clearTimeout(this._imgTimer);
            this._imgTimer = setTimeout(swap, 3000);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // 排序下拉：改了就提交（无 JS 时 noscript 里有按钮）
  document.querySelectorAll('.jn-search-page__sort[data-auto-submit]').forEach(function (form) {
    var select = form.querySelector('select');
    if (select) select.addEventListener('change', function () { form.submit(); });
  });

  } catch(e) { console.error(e); }
})();
})();
